import { AsyncPipe, isPlatformServer } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { GalleryDto, TenantDto } from '@nusign/picflow-backend-types';
import { VideoOriginPipe } from '../../../gallery/pipes/video-origin.pipe';
import { GalleryCoverUrlPipe } from '../../../shared/pipes/gallery-cover-url.pipe';
import { loadGalleryFonts } from '../../lib/load-gallery-fonts';
import { VideoViewerComponent } from '../video-viewer/video-viewer.component';

@Component({
  selector: 'app-gallery-cover',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VideoViewerComponent, VideoOriginPipe, GalleryCoverUrlPipe, AsyncPipe],
  templateUrl: './gallery-cover.component.html',
  styleUrl: './gallery-cover.component.scss',
})
export class GalleryCoverComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);
  @Input() gallery: GalleryDto;
  @Input() tenant: TenantDto;
  @Input() darkGalleryBackground: boolean;

  getFontSize(size: number) {
    if (size === 1) return 'small';
    if (size === 2) return 'medium';
    if (size === 3) return 'large';
    if (size === 4) return 'huge';
  }

  ngOnInit(): void {
    if (isPlatformServer(this.platformId)) return;
    loadGalleryFonts(this.gallery, this.tenant);
  }
}
